module.exports = __webpack_public_path__ + "static/media/programming_languages.86bdd3a5.svg";